import { UserActions } from './user.actions';
import { UserState } from './user.state';

export function userReducer(state: UserState, action: UserActions): UserState {
  //console.log(action);
  switch (action.type) {
    case 'set-user-loading':
      return { ...state, loading: action.isLoading };
    case 'set-user-data':
      return { ...state, ...action.data };
    case 'set-username':
      return { ...state, username: action.username };
    case 'set-userced':
      return { ...state, userced: action.userced };
    case 'set-userid':
      return { ...state, userid: action.userid };
    case 'set-userother':
      return { ...state, userother: action.userother };
    case 'set-eventcode':
      return { ...state, eventcode: action.eventcode };
    case 'set-event-name':
      return { ...state, eventName: action.eventName };
    case 'set-event-start-date':
      return { ...state, eventStartDate: action.eventStartDate };
    case 'set-event-end-date':
      return { ...state, eventEndDate: action.eventEndDate };
    case 'set-event-location':
      return { ...state, eventLocation: action.eventLocation };
    case 'set-has-seen-tutorial':
      return { ...state, hasSeenTutorial: action.hasSeenTutorial };
    case 'set-dark-mode':
      return { ...state, darkMode: action.darkMode };
    case 'set-is-loggedin':
      return { ...state, isLoggedin: action.loggedIn };
    case 'set-email':
      return { ...state, email: action.email };
    case 'set-phone':
      return { ...state, phone: action.phone };
    case 'set-company':
      return { ...state, company: action.company };
    case 'set-position':
      return { ...state, position: action.position };
    case 'set-profile-photo-url':
      return { ...state, profilePhotoUrl: action.profilePhotoUrl };
  }
  return state;
}